var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"CscContact"},[_c('header-background',{staticClass:"CscContact-Header",attrs:{"height":300,"image-src":_vm.headerImageSrc,"title":"Contato"}}),_c('contact-block',{on:{"alert":_vm.handleAlert}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }